import { Button } from "@mui/material";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(() => ({
  supportPhone: {
    marginTop: 12,
    fontSize: 16,
    fontWeight: 500,
  },

  lkLink: {
    marginTop: 15,
    display: "inline-block",
    fontSize: 16,
    color: "#1976d2",
    textDecoration: "none",
  },
  errorWrapper: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    textAlign: "center",
    padding: "40px 20px",
    color: "#000",
    justifyContent: "center",

  },

  errorTitle: {
    fontSize: "18px",
    fontWeight: 600,
    marginBottom: "8px",
     color: "#d32f2f",
  },

  errorSubtitle: {
    fontSize: "14px",
    color: "#555",
    marginBottom: "20px",
  },
  button: {
    backgroundColor: "#5664F5",
    height: "40px",
    fontSize: 16,
    fontWeight: 600,
    borderRadius: "10px",
    color: "#fff",
    "&:hover": {
      backgroundColor: "#4352d6",
    },
    fontFamily: "Montserrat",
  },
}));

interface Props {
  orgParam: string | null;
  handleRetry: () => void;
}

function ServiceUnavailable({ orgParam, handleRetry }: Props) {
  const classes = useStyles();

  const getSupportInfo = () => {
    switch (orgParam) {
      case 'АО "РИЦ"':
        return {
          orgName: 'АО "РИЦ"',
          phone: process.env.REACT_APP_SUPPORT_PHONE_RIC || "",
          link: "https://flk.ricso.ru",
        };
      case 'ООО "ЮРИЦ"':
        return {
          orgName: 'ООО "ЮРИЦ"',
          phone: process.env.REACT_APP_SUPPORT_PHONE_URIC || "",
          link: "https://flk.vostok-electra.ru/login",
        };
      case 'АО "ЕРИЦ ЯНАО"':
        return {
          orgName: 'АО "ЕРИЦ ЯНАО"',
          phone: process.env.REACT_APP_SUPPORT_PHONE_ERIC || "",
          link: "https://flk.vostok-electra.ru/login",
        };
      default:
        return {
          orgName: "АО «ЭК «Восток»",
          phone: process.env.REACT_APP_SUPPORT_PHONE || "",
          link: "https://flk.vostok-electra.ru/login",
        };
    }
  };

  const support = getSupportInfo();

   return (
    <div className={classes.errorWrapper}>
      <div className={classes.errorTitle}>Сервис временно недоступен</div>
      <div className={classes.errorSubtitle}>
        Не удалось получить данные по задолженности. Пожалуйста, свяжитесь с
        колл-центром вашей организации или воспользуйтесь Личным кабинетом.
      </div>
      <div style={{marginBottom: '-5px'}} className={classes.supportPhone}>
        {support.orgName}
      </div>
      <div className={classes.supportPhone}>
        {support.phone}
      </div>

      <a
        href={support.link}
        target="_blank"
        rel="noopener noreferrer"
        className={classes.lkLink}
      >
        Перейти в Личный кабинет
      </a>
      <Button
        onClick={handleRetry}
        style={{ marginTop: "20px", padding: "20px" }}
        className={classes.button}
      >
        Обновить
      </Button>
    </div>
  );
}

export default ServiceUnavailable;
